class GlobalLocationsCarousel {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('[data-location-track]');
    this.slides = Array.from(section.querySelectorAll('[data-location-slide]'));
    this.prevButton = section.querySelector('[data-location-prev]');
    this.nextButton = section.querySelector('[data-location-next]');
    this.dots = Array.from(section.querySelectorAll('[data-location-dot]'));
    this.index = 0;
    this.timer = null;
    this.startX = 0;
    this.deltaX = 0;

    if (!this.track || this.slides.length < 1) return;

    this.autoplay = section.dataset.autoplay === 'true';
    this.speed = Number(section.dataset.speed) || 4000;

    this.bindEvents();
    this.update();
    this.startAutoplay();
  }

  bindEvents() {
    this.prevButton?.addEventListener('click', () => this.goTo(this.index - 1));
    this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1));

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.goTo(Number(dot.dataset.locationDot)));
    });

    this.section.addEventListener('mouseenter', () => this.stopAutoplay());
    this.section.addEventListener('mouseleave', () => this.startAutoplay());
    this.section.addEventListener('focusin', () => this.stopAutoplay());
    this.section.addEventListener('focusout', () => this.startAutoplay());

    this.track.addEventListener('pointerdown', (event) => {
      this.startX = event.clientX;
      this.deltaX = 0;
      this.track.setPointerCapture?.(event.pointerId);
    });

    this.track.addEventListener('pointermove', (event) => {
      if (!this.startX) return;
      this.deltaX = event.clientX - this.startX;
    });

    this.track.addEventListener('pointerup', () => {
      if (Math.abs(this.deltaX) > 55) {
        this.goTo(this.index + (this.deltaX < 0 ? 1 : -1));
      }
      this.startX = 0;
      this.deltaX = 0;
    });

    window.addEventListener('resize', () => this.update());

    document.addEventListener('shopify:block:select', (event) => {
      const selectedSlide = event.target.closest?.('[data-location-slide]');
      if (!selectedSlide || !this.section.contains(selectedSlide)) return;
      this.goTo(Number(selectedSlide.dataset.index), false);
    });
  }

  goTo(index, restart = true) {
    const total = this.slides.length;
    this.index = (index + total) % total;
    this.update();

    if (restart) {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  update() {
    this.track.style.transform = `translate3d(-${this.index * 100}%, 0, 0)`;

    this.slides.forEach((slide, slideIndex) => {
      const active = slideIndex === this.index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    this.dots.forEach((dot, dotIndex) => {
      const active = dotIndex === this.index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  startAutoplay() {
    if (!this.autoplay || this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.stopAutoplay();
    this.timer = window.setInterval(() => this.goTo(this.index + 1, false), this.speed);
  }

  stopAutoplay() {
    if (this.timer) window.clearInterval(this.timer);
    this.timer = null;
  }
}

function initGlobalLocations(root = document) {
  root.querySelectorAll('[data-global-locations]').forEach((section) => {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';
    new GlobalLocationsCarousel(section);
  });
}

document.addEventListener('DOMContentLoaded', () => initGlobalLocations());
document.addEventListener('shopify:section:load', (event) => initGlobalLocations(event.target));
